/**
 * Same OPEN motion as the account menu (`FetchMenubar`'s `MENU_CONTENT_MOTION_CLASS`): a
 * directional slide-and-fade in, by side. The switchers (tool, org, event) used to open with a
 * scale-in, which read as slightly different chrome from every other popover in the rail.
 *
 * The CLOSE deliberately does NOT reuse `MENU_CONTENT_MOTION_CLASS`'s `fadeOut` (200ms) — on this
 * 260px switcher surface that read as sluggish, the dismiss visibly lagging the click that caused
 * it. `quick-fade-out` is the same plain opacity fade at half the duration (100ms): a close should
 * feel quicker than the open it undoes, not match it beat for beat.
 */
export const SWITCHER_POPOVER_CLASS =
  "z-50 w-[260px] overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-lg shadow-gray-900/8 outline-none " +
  "data-[state=open]:data-[side=top]:animate-slideUpAndFade " +
  "data-[state=open]:data-[side=right]:animate-slideRightAndFade " +
  "data-[state=open]:data-[side=left]:animate-slideLeftAndFade " +
  "data-[state=open]:data-[side=bottom]:animate-slideDownAndFade " +
  "data-[state=closed]:animate-quick-fade-out";

export const SWITCHER_SEARCH_INPUT_CLASS =
  "border-0 rounded-none bg-transparent text-sm shadow-none focus:border-0 focus:shadow-none focus:ring-0";
